import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { ABOUT_PROFILE_PHOTO } from '../../../media';

export default function Background() {
  const { t } = useTranslation();

    return (
        <section className="bg-warm-white py-24 lg:py-32">
            <div className="max-w-6xl mx-auto px-6 lg:px-12">
                <div className="mb-14">
                    <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium">{t('about.bg.badge')}</span>
                    <div className="w-10 h-px bg-sage mt-3" />
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
                    <div>
                        <h2 className="font-cormorant text-4xl md:text-5xl font-light text-charcoal leading-[1.2] mb-8">
                            <Trans
                                i18nKey="about.bg.headline"
                                components={{
                                    italic: <em />
                                }}
                            />
                        </h2>
                        <p className="text-base text-text-muted font-inter leading-[1.8] mb-6">
                            {t('about.bg.p1')}
                        </p>
                        <p className="text-base text-text-muted font-inter leading-[1.8]">
                            {t('about.bg.p2')}
                        </p>
                    </div>
                    <div>
                        <div className="bg-canvas rounded-2xl p-8 border border-sage/20 mb-7">
                            <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium block mb-4">
                                <strong>{t('about.bg.foundationBadge')}</strong>
                            </span>
                            <span className="text-base text-text-muted font-inter leading-[1.8] mb-4">
                                <Trans
                                    i18nKey="about.bg.foundationText"
                                    components={{
                                        italic: <em />,
                                        bold: <strong />
                                    }}
                                />
                            </span>
                            <div className="flex items-center gap-2 mt-4 pt-4 border-t border-sage/10">
                                <i className="ri-verified-badge-line text-sage" />
                                <span className="text-sm font-inter font-medium text-charcoal">
                                    {t('about.bg.verified')}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
